<script setup lang="ts">
import { useRoute } from "vue-router";

const route = useRoute();
const isHomePage = computed(() => route.path === "/");
const isClient = ref(false);

const tours = useTourStore();
tours.fetchTours();

onMounted(() => {
  isClient.value = true;
});
</script>

<template>
  <!-- {{ data.data }} -->

  <Hero />

  <div v-if="isHomePage">
    <!-- check if only on index url -->
    <h2
      class="m-4 mb-6 text-center text-lg font-semibold uppercase text-[#535353]"
    >
      Favorite Tours
    </h2>
    <ClientOnly>
      <FeatureSlider />
    </ClientOnly>
  </div>
  <ClientOnly>
    <NuxtErrorBoundary>
      <NuxtPage />
    </NuxtErrorBoundary>
  </ClientOnly>
  <div class="mx-4 mb-8 mt-2 h-[0.5px] border-b border-[#ddd]"></div>
  <Destinations />
  <TheFooter />
</template>
